var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("coupon-send-config", {
    attrs: {
      id: _vm.id,
      "send-type": _vm.sendType,
      "allowed-events": [4],
      "default-event": 4,
      "event-fixed": true,
      "show-theme-tab": true,
    },
    on: { success: _vm.handleSuccess, cancel: _vm.handleCancel },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }